import { useQueryClient } from '@tanstack/react-query';

import { type CommunityNotificationSettings, createCommunityNotificationSettings } from 'models';

import { useMutation } from 'query';
import type { CommunityNotificationSettingsFormValues as CommunityNotificationSettingsValues } from '../../components';
import { type UpdateNotificationsSettingsRequest, updateNotificationsSettings } from '../../services';
import { getCommunityNotificationsKey } from '../keys';

export const useUpdateNotificationSettingsMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<CommunityNotificationSettings, { id: string; values: CommunityNotificationSettingsValues }>({
    async mutationFn({ id, values }) {
      const data: UpdateNotificationsSettingsRequest = {
        email_notifications_settings: {
          events: values.emailNotificationsSettings?.events,
          giving: values.emailNotificationsSettings?.giving,
          newsfeed: values.emailNotificationsSettings?.newsfeed,
          program: values.emailNotificationsSettings?.program,
        },
        push_notifications_settings: {
          events: values.pushNotificationsSettings?.events,
          giving: values.pushNotificationsSettings?.giving,
          newsfeed: values.pushNotificationsSettings?.newsfeed,
          program: values.pushNotificationsSettings?.program,
        },
      };

      data.email_notifications_settings.enable_notifications = Object.values(data.email_notifications_settings).some(
        Boolean,
      );
      data.push_notifications_settings.enable_notifications = Object.values(data.push_notifications_settings).some(
        Boolean,
      );

      const communityResponse = await updateNotificationsSettings({
        data,
        id,
      });

      return createCommunityNotificationSettings(communityResponse.data);
    },
    onSuccess(data, input) {
      queryClient.setQueryData(getCommunityNotificationsKey({ id: input.id }), data);
    },
  });
};
